export class PasswordReset {
  public externalId!: string;
  public newPassword!: string;

  constructor(values?: PasswordReset) {
    Object.assign(this, values);
  }
}
